module.exports = __webpack_public_path__ + "static/media/ANS.368aaea6.jpg";